import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../../modules/commons/Container";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../../modules/SimpleDDL";
import Api from "../../../../Services/Api";
import {mapToObjectDDL, removeNullFields} from "../../../common/mapper";
import BelumPenagihan from "./belumPenagihan/belumPenagihan";
import {TabLabels} from "./config";
import Pelunasan from "./pelunasan/pelunasan";
import SudahPenagihan from "./sudahPenagihan/sudahPenagihan";
import * as R from "ramda";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class SalesOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterData: {},
            searchData: {},
            submittedFilterData: {},
            kodeCabang: null,
            cabangOptions: [],
            tabIndex: 0,
            dataTable: [],
            loading: false,
            pagination: {
                totalData: 0,
                limit: 5,
                page: 1,
            },
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        if (this.props.menuAccess && this.props.menuAccess.length > 0) {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        cabangOptions: filteredData.map(data => mapToObjectDDL(data.namaDealer, data.kodeCabang)),
                        kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                    }));

                    await this.fetchData({kodeCabang: filteredData[0]?.kodeCabang});
                }
            }
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        if (!R.equals(prevState.tabIndex, this.state.tabIndex)) {
            this.setState((prevValue) => ({...prevValue, loading: true}));
            await this.fetchData({kodeCabang: this.state.kodeCabang?.value});
            this.setState((prevValue) => ({...prevValue, loading: false}));
        }
        if (prevState.pagination.limit !== this.state.pagination.limit ||
            prevState.pagination.page !== this.state.pagination.page) {
            this.setState((prevValue) => ({...prevValue, loading: true}));
            await this.fetchData(this.state.submittedFilterData, this.state.pagination.page, this.state.pagination.limit);
            this.setState((prevValue) => ({...prevValue, loading: false}));

        }
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        let {tabIndex} = this.state;
        this.setState((prevValue) => ({
            prevValue,
            submittedFilterData: {...filter},
        }));

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getAllLeasingPayment,
            menuName: `Penagihan Leasing - ${tabIndex === 0 ? "Belum Penagihan" : tabIndex === 1 ? "Sudah Penagihan" : "Pelunasan"}`,
            setError: this.props.setError,
            args: {
                paramFilters: {
                    kodeCabang: this.state.kodeCabang?.value || "",
                    listPaymentStatus: tabIndex === 0 ? ["BELUM_PENAGIHAN"] : tabIndex === 1 ? ["SUDAH_PENAGIHAN"] : ["SUDAH_PENAGIHAN", "PELUNASAN"],
                    ...filter,
                },
                limit,
                page,
            }
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data?.data || [],
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data?.totalData,
                    page,
                    limit,
                }
            }));
        }
    };

    handleChangePage = (page) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page,
            },
        }));
    };

    handleRowsPerPage = (limit) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 0,
                limit,
            },
        }));
    };

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
            ...prevValue, loading: true, searchData: {},
            pagination: {...prevValue.pagination, page: 1, totalData: 0}
        }));
        const request = removeNullFields({
            ...this.state.filterData,
            listNamaWarna: this.state.filterData?.listNamaWarna?.map((nm) => nm.value),
            listNamaLeasing: this.state.filterData?.listNamaLeasing?.map((nl) => nl.value),
            listNamaType: this.state.filterData?.listNamaType?.map((nt) => nt.label),
            listStatusPelunasan: this.state.filterData?.listStatusPelunasan?.map((ps) => ps.value),
        });
        await this.fetchData(request);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
        }));
    };

    handleSubmitSearch = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true, filterData: {}}));
        let key;
        if (this.state.searchData?.nameDDL?.value === "STNK") {
            key = "namaSTNK";
        } else {
            key = "namaPembeli";
        }

        const request = {
            [key]: this.state.searchData?.nameInput || "",
        };
        await this.fetchData(request);
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleSearchChange = (key, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {
                ...prevValue.searchData,
                [key]: value,
            },
        }));
    };

    handleFilterChange = (key, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [key]: value,
            },
        }));
    };

    handleClearFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                listStatusPelunasan: null,
                listNamaWarna: null,
                listNamaType: null,
                listNamaLeasing: null,
            },
        }));
    };

    handleClearSearch = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {},
            filterData: {},
            loading: true,
        }));
        await this.fetchData();
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleCabangChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
            dataTable: [],
            searchData: {},
            filterData: {},
            loading: true,
        }));
        await this.fetchData({
            kodeCabang: value.value,
        });
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
        }));
    };

    refetch = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        await this.fetchData({}, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    render() {
        return (
            <>
                <Container>
                    <SimpleDDL
                        id="select_options_nama_cabang"
                        box="search"
                        name="kodeCabang"
                        containerclassname="width width-250px"
                        placeholder="Nama cabang hak akses"
                        options={this.state.cabangOptions}
                        value={this.state.kodeCabang}
                        onChange={(value, {name}) => this.handleCabangChange(name, value)}
                    />
                    <Tabs
                        selectedIndex={this.state.tabIndex}
                        onSelect={(index) =>
                            this.setState((prevValue) => ({
                                ...prevValue,
                                tabIndex: index,
                                dataTable: [],
                                filterData: {},
                                searchData: {},
                                submittedFilterData: {},
                                pagination: {
                                    totalData: 1,
                                    page: 1,
                                    limit: 5,
                                },
                            }))
                        }
                    >
                        <TabList>
                            <Tab>{TabLabels.BELUM_PENAGIHAN}</Tab>
                            <Tab>{TabLabels.SUDAH_PENAGIHAN}</Tab>
                            <Tab>{TabLabels.PELUNASAN}</Tab>
                        </TabList>
                        <TabPanel>
                            <BelumPenagihan
                                {...this.props}
                                state={this.state}
                                refetch={this.refetch}
                                onClearSearch={this.handleClearSearch}
                                onSubmitSearch={this.handleSubmitSearch}
                                onSearchChange={this.handleSearchChange}
                                onClearFilter={this.handleClearFilter}
                                onFilterChange={this.handleFilterChange}
                                onSubmitFilter={this.handleSubmitFilter}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleRowsPerPage}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SudahPenagihan
                                {...this.props}
                                state={this.state}
                                refetch={this.refetch}
                                onClearSearch={this.handleClearSearch}
                                onSubmitSearch={this.handleSubmitSearch}
                                onSearchChange={this.handleSearchChange}
                                onClearFilter={this.handleClearFilter}
                                onFilterChange={this.handleFilterChange}
                                onSubmitFilter={this.handleSubmitFilter}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleRowsPerPage}
                            />
                        </TabPanel>
                        <TabPanel>
                            <Pelunasan
                                {...this.props}
                                state={this.state}
                                refetch={this.refetch}
                                onClearSearch={this.handleClearSearch}
                                onSubmitSearch={this.handleSubmitSearch}
                                onSearchChange={this.handleSearchChange}
                                onClearFilter={this.handleClearFilter}
                                onFilterChange={this.handleFilterChange}
                                onSubmitFilter={this.handleSubmitFilter}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleRowsPerPage}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(SalesOrder);
